(function metadataDefinition() {
    'use strict';
    angular.module('Entities')
        .service('metadataService', [
            'restUrlBuilder', 'errorsExtend', 'messages', 'configViewService', function metadataService(restUrlBuilder, errors, messages, configViewService) {
                restUrlBuilder = restUrlBuilder('wf');

                this.getById = function (id) {
                    var params = { Id: id };

                    return restUrlBuilder.one('Metadatas').get({ params: params });
                };

                this.get = function get(find) {
                    var params = {
                        OrganizationUnitId: find.organizationUnitId,
                        Name: find.name,
                        SystemName: find.systemName,
                        Global: find.global
                    };

                    return restUrlBuilder.all('Metadatas').get({ params: params });
                };

                this.create = function cretateMetadata(metadata) {
                    var params = {
                        Name: metadata.name,
                        SystemName: metadata.systemName,
                        OrganizationUnitId: metadata.organizationUnitId,
                        OrganizationUnitName: metadata.organizationUnitName,
                        OptionValues: metadata.optionValues,
                        Type: metadata.type
                    };

                    return restUrlBuilder.all('Metadatas').post(params);
                };

                this.modify = function modifyMetadata(metadata) {
                    var params = {
                        id: metadata.id,
                        name: metadata.label,
                        systemName: metadata.systemName,
                        type: metadata.dataType,
                        organizationUnitId: metadata.organizationalUnitId,
                        organizationUnitName: metadata.organizationalUnitName,
                        optionValues: metadata.optionValues
                    };

                    return restUrlBuilder.all('Metadatas').put(params);
                };

            }
        ]);
})();
